module.exports = __webpack_public_path__ + "static/media/FeedManufacturingSolutionblue.fcbde8f7.svg";